import { render, staticRenderFns } from "./linked-budget-request-form.vue?vue&type=template&id=2f73dc32"
import script from "./linked-budget-request-form.ts?vue&type=script&lang=ts&external"
export * from "./linked-budget-request-form.ts?vue&type=script&lang=ts&external"
import style0 from "./linked-budget-request-form.scss?vue&type=style&index=0&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f73dc32')) {
      api.createRecord('2f73dc32', component.options)
    } else {
      api.reload('2f73dc32', component.options)
    }
    module.hot.accept("./linked-budget-request-form.vue?vue&type=template&id=2f73dc32", function () {
      api.rerender('2f73dc32', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/project-portfolio/linked-budget-request-edit/linked-budget-request-form/linked-budget-request-form.vue"
export default component.exports